import axios from "axios";

export const getVinPage = function (params) {
  return axios({
    method: "get",
    url: `/api/app/cpCard/vinPage`,
    withCredentials: true,
    timeout: 10000,
    params,
  });
};

export const getPlate = function (params) {
  return axios({
    method: "get",
    url: `/api/app/cpCard/plateList`,
    withCredentials: true,
    timeout: 10000,
    params,
  });
};

export const getCpCardList = function (vin) {
  return axios({
    method: "get",
    url: `/api/app/cpCard/detail`,
    withCredentials: true,
    timeout: 10000,
    params: {
      vin,
    },
  });
};

// 可购买月卡
export const getCpCardListByVin = function (vin) {
  return axios({
    method: "get",
    url: `/api/app/cpCard/forSale`,
    withCredentials: true,
    timeout: 10000,
    params: {
      vin,
    },
  });
};

// 生成订单
export const createOrder = function (data) {
  return axios({
    method: "post",
    url: `/api/app/cpCard/order`,
    withCredentials: true,
    timeout: 10000,
    data,
  });
};

// 支付订单
export const payOrder = function (data) {
  return axios({
    method: "post",
    url: `/api/app/cpCard/pay`,
    withCredentials: true,
    timeout: 10000,
    data,
  });
};

// 购买记录
export const getOrderList = function (params) {
  return axios({
    method: "get",
    url: `/api/app/cpCard/orderList`,
    withCredentials: true,
    timeout: 10000,
    params,
  });
};

// 查询支付状态
export const getPayStatus = function (params) {
  return axios({
    method: "get",
    url: `/api/app/cpCard/payStatus`,
    withCredentials: true,
    timeout: 10000,
    params,
  });
};

// 检测是否允许购买
export const checkCanBuy = function (params) {
  return axios({
    method: "get",
    url: `/api/app/cpCard/preCheck`,
    withCredentials: true,
    timeout: 10000,
    params,
  });
};
